import React from 'react'
import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { withTranslations } from 'widgets-shared/core'
import { TranslationFunction } from 'smartstream-widgets/types/sharedModule/core'
import { withComponentContext } from 'widgets-shared/core'
import { Typography } from '@mui/material'
import { compose } from 'widgets-shared/core'
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme'
import DynamicImage from 'smartstream-widgets/controls/DynamicImage/DynamicImage'

type Props = {
    classes: {
      [K in string]: string
    },
    config: {
      BASE_ASSET_PATH: string,
    },
    translations: {
      [K in string]: string
    }
  }
  

const styles = (theme: Theme) =>  createStyles({
    root: {},
    oddsByLabel: {
        fontSize: 28,
        fontWeight: 'bold',
        marginRight: 14,
        marginBottom: 16,
        [theme.breakpoints.up('cs')]: {
            marginBottom: 0
        },
    },

  })
  

const OddsByHeader = (props: Props) => {
    const {
        classes,
        translations,
        config: {
          BASE_ASSET_PATH
        },
    } = props
    return (
        <div className={classes.root}>
            <Typography className={classes.oddsByLabel}>{translations.oddsTitle}</Typography>
            <DynamicImage supportedFormats={['webp']}>
              <img
              src={`${BASE_ASSET_PATH}/img/genius.svg`}
              alt='Powered by Genius'
              />
            </DynamicImage>
        </div>
    )
}

export default compose(
    withComponentContext,
    withTranslations((t: TranslationFunction) => {
        return {
            oddsTitle: t('oddsTitle.translation', {
                defaultValue: 'Available Odds',
                context: 'label for Available Odds'
          })
        }
      }),
    withStyles(styles, { name: 'OddsByHeader', withTheme: true, defaultTheme: getDefaultTheme })
)(OddsByHeader)
